import store from './store'

var dashboard = [
  {
    name: '홈',
    url: '/dashboard',
    icon: 'cui-dashboard'
  }
]
var remnant = [
  {
    title: true,
    name: '렘넌트',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  },
  {
    name: '장학금 신청',
    url: '/Apply/regist',
    icon: 'cui-pencil'
  }
]
var remnantLong = [
  {
    title: true,
    name: '렘넌트',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  },
  {
    name: '레포트 제출',
    url: '/Apply/regist',
    icon: 'cui-pencil'
  }
]
var remnantCommon = [
  {
    name: '내 정보',
    url: '/remnant/regist',
    icon: 'cui-user'
  },
  {
    name: '내 과거 기록',
    url: '/remnant/pastinfo',
    icon: 'icon-docs'
  }
]
var everyOne = [
  {
    title: true,
    name: '기탁서',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  },
  {
    name: '기탁서 작성',
    url: '/donate/regist',
    icon: 'cui-pencil'
  },
  {
    name: '기탁서 조회',
    url: '/donate/regist?check=1',
    icon: 'cui-magnifying-glass'
  },
  {
    title: true,
    name: '자료',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  },
  {
    name: '역대 수여식',
    url: '/document/interview',
    icon: 'icon-social-youtube'
  }
]
var partAdmin = [
  {
    title: true,
    name: '부서심의',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  },
  {
    name: '신청서 리스트',
    url: '/part/list/apply',
    icon: 'cui-list'
  },
  {
    name: '부서 회의록',
    url: '/part/logs',
    icon: 'cui-comment-square'
  }
]
var superAdmin = [
  {
    title: true,
    name: '관리자',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  },
  {
    name: '기탁서 리스트',
    url: '/admin/list/donate',
    icon: 'cui-list'
  },
  {
    name: '렘넌트 리스트',
    url: '/admin/list/remnant',
    icon: 'cui-list'
  },
  {
    name: '최종 정보',
    url: '/admin/list/final',
    icon: 'cui-list'
  },
  {
    name: 'OMC 정보',
    url: '/admin/list/omc',
    icon: 'cui-list'
  },
  {
    name: '회의록',
    url: '/admin/logs',
    icon: 'cui-comment-square'
  }
]
var realSuperAdmin = [
  {
    title: true,
    name: '관리자',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  },
  {
    name: '기탁서 리스트',
    url: '/admin/list/donate',
    icon: 'cui-list'
  },
  {
    name: '렘넌트 리스트',
    url: '/admin/list/remnant',
    icon: 'cui-list'
  },
  {
    name: '최종 정보',
    url: '/admin/list/final',
    icon: 'cui-list'
  },
  {
    name: 'OMC 정보',
    url: '/admin/list/omc',
    icon: 'cui-list'
  },
  {
    name: '회의록',
    url: '/admin/logs',
    icon: 'cui-comment-square'
  },
  {
    name: 'Contols',
    url: '/admin/control',
    icon: 'cui-cog'
  }
]
export default {
  dDay () {
  },
  itemList () {
    var items = []
    if (store.getters.isRealSuper) {
      /* 장학부 */
      items = dashboard.slice().concat(partAdmin).concat(realSuperAdmin)
      if (store.state.LONGTERM > 0) {
        items = items.slice().concat(remnantLong)
      } else {
        items = items.slice().concat(remnant)
      }
      items = items.slice().concat(remnantCommon).concat(everyOne)
    } else if (store.getters.isSuper) {
      /* 장학부 */
      items = dashboard.slice().concat(partAdmin).concat(superAdmin)
      if (store.state.LONGTERM > 0) {
        items = items.slice().concat(remnantLong)
      } else {
        items = items.slice().concat(remnant)
      }
      items = items.slice().concat(remnantCommon).concat(everyOne)
    } else if (store.getters.isPartAuth) {
      /* 부서 관리자 */
      items = dashboard.slice().concat(partAdmin)
    } else {
      /* 일반인 */
      var submitted = store.state.SUBMITTED
      items = dashboard.slice()
      if (store.state.LONGTERM > 0) {
        if (submitted > 0) {
          remnantLong[1].name = '레포트 수정'
        } else {
          remnantLong[1].name = '레포트 제출'
        }
        items = items.slice().concat(remnantLong)
      } else {
        if (submitted > 0) {
          remnant[1].name = '신청서 수정'
        } else {
          remnant[1].name = '장학금 신청'
        }
        items = items.slice().concat(remnant)
      }
      items = items.slice().concat(remnantCommon).concat(everyOne)
    }
    return items
  }
}
